import { Link } from "react-router-dom";

const currencyFormatter = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
});

const StoreProductCard = ({ product, variant = "grid" }) => {
  const images = Array.isArray(product.images) ? product.images : [];

  const title = product.title || product.name;
  const description = product.description || product.subtitle;
  const price = product.price ?? null;
  const promotionalPrice = product.promotionalPrice ?? null;
  const originalPrice = product.originalPrice ?? (promotionalPrice !== null ? price : null);
  const points = product.points ?? null;
  const currentPrice = promotionalPrice !== null && promotionalPrice !== undefined ? promotionalPrice : price;
  const hasCurrentPrice = currentPrice !== null && currentPrice !== undefined && Number.isFinite(Number(currentPrice));
  const hasOriginalPrice =
    originalPrice !== null &&
    originalPrice !== undefined &&
    currentPrice !== null &&
    currentPrice !== undefined &&
    Number(originalPrice) > Number(currentPrice);
  const hasPoints = points !== null && points !== undefined && Number.isFinite(Number(points));
  const badgeText = product.badge || (hasOriginalPrice ? "Oferta" : hasPoints ? "Pontos" : "");
  const productPath = `/store/produto/${encodeURIComponent(product.id)}`;

  return (
    <article className={`store-product-card store-product-card--${variant}`}>
      <Link
        to={productPath}
        className={`store-product-media ${images.length > 0 ? "has-images" : ""} ${images.length > 1 ? "has-hover-image" : ""} tone-${product.tone || "midnight"}`}
        aria-label={`Ver detalhes de ${title}`}
      >
        {badgeText ? <span className="store-product-badge">{badgeText}</span> : null}

        {images.length > 0 ? (
          <>
            {images.slice(0, 2).map((image, index) => (
              <div
                key={image.id || `${title}-${index}`}
                className={`store-product-image-slide ${index === 0 ? "is-active" : "is-hover"}`}
              >
                <img src={image.url} alt={title} />
              </div>
            ))}
          </>
        ) : (
          <div className="store-product-art">
            <strong>{product.artLabel || title}</strong>
            {product.artSubLabel ? <span>{product.artSubLabel}</span> : null}
          </div>
        )}
      </Link>

      <div className="store-product-body">
        {product.minOrder || product.delivery ? (
          <div className="store-product-topline">
            {product.minOrder ? <span>{product.minOrder}</span> : null}
            {product.delivery ? <span>{product.delivery}</span> : null}
          </div>
        ) : null}

        <h3>{title}</h3>
        {description ? <p>{description}</p> : null}

        <div className="store-product-footer">
          {hasCurrentPrice || hasPoints ? (
            <div className="store-product-pricing">
              {hasCurrentPrice ? (
                <strong>{currencyFormatter.format(Number(currentPrice))}</strong>
              ) : null}
              {hasOriginalPrice ? <span>{currencyFormatter.format(Number(originalPrice))}</span> : null}
              {hasPoints ? <small>{Number(points)} pontos</small> : null}
            </div>
          ) : <div className="store-product-pricing empty" />}

          <Link to={productPath} className="store-product-action">
            Ver produto
          </Link>
        </div>
      </div>
    </article>
  );
};

export default StoreProductCard;
